import { defineStore } from 'pinia'
import { ref, computed } from 'vue'
import { client } from '@/api/client.gen'

export interface UserProfile {
  id?: number
  username: string
  phone: string
  avatar?: string | null
  level?: number
  invite_code?: string
  balance?: number
  red_flower?: number
  points?: number
  fans_count?: number
  follows_count?: number
  articles_count?: number
  likes_count?: number
}

function applyToken(t: string | null) {
  client.setConfig({
    headers: t ? { Authorization: t } : {},
  })
}

export const useAuthStore = defineStore(
  'auth-store',
  () => {
    const token = ref<string | null>(null)
    const refreshToken = ref<string | null>(null)
    const user = ref<UserProfile | null>(null)
    const loginTimestamp = ref<number | null>(null)

    const isLoggedIn = computed(() => !!token.value && !!user.value)

    function setAuth(newToken: string, newUser: UserProfile, newRefreshToken?: string) {
      token.value = newToken
      user.value = newUser
      loginTimestamp.value = Date.now()
      if (newRefreshToken !== undefined) {
        refreshToken.value = newRefreshToken
      }
      applyToken(newToken)
    }

    function logout() {
      token.value = null
      refreshToken.value = null
      user.value = null
      loginTimestamp.value = null
      applyToken(null)
    }

    // 恢复持久化 token（应用启动时由 main.ts 调用）
    function restoreToken() {
      if (token.value) {
        applyToken(token.value)
      }
    }

    function updateUser(partial: Partial<UserProfile>) {
      if (user.value) {
        user.value = { ...user.value, ...partial }
      }
    }

    return {
      token,
      refreshToken,
      user,
      loginTimestamp,
      isLoggedIn,
      setAuth,
      updateUser,
      logout,
      restoreToken,
    }
  },
  { persist: true },
)
